module.exports = __webpack_public_path__ + "static/media/9.b3fd1e90.jpg";